import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import baseUrl from "../../api/baseUrl";
import {RootState} from "../index";
import PageableDto from "../../dto/PageableDto";
import ExpenseCreateRequestDto from "../../dto/ExpenseCreateRequestDto";
import SearchExpensesRequestDto from "../../dto/SearchExpensesRequestDto";
import ExpenseUpdateRequestDto from "../../dto/ExpenseUpdateRequestDto";
import ExpenseDto from "../../dto/ExpenseDto";

const expenseApi = createApi({
    reducerPath: "expense",
    tagTypes: ['Expenses'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/api/v1/expense`,
        prepareHeaders: (headers, {getState}) => {
            const token = (getState() as RootState).auth.token;

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        createExpense: builder.mutation({
            query: (body: ExpenseCreateRequestDto) => { // todo: clean up interfaces dtos and interfaces folder to one place
                return {
                    url: '',
                    method: 'POST',
                    body: body
                }
            },
            invalidatesTags: ['Expenses'],
        }),
        updateExpense: builder.mutation({
            query: (body: ExpenseUpdateRequestDto) => {
                return {
                    url: `/${body.id}`,
                    method: 'PUT',
                    body: body
                }
            },
            invalidatesTags: ['Expenses'],
        }),
        deleteExpense: builder.mutation({
            query: (id) => {
                return {
                    url: `/${id}`,
                    method: 'DELETE'
                }
            },
            invalidatesTags: ['Expenses'],
        }),
        fetchExpenses: builder.query<PageableDto<ExpenseDto[]>, SearchExpensesRequestDto>({
            query: (request: SearchExpensesRequestDto) => {
                return {
                    url: `/search`,
                    method: 'POST',
                    body: request
                }
            },
            providesTags: ['Expenses'],
        }),
    })
});

export const {
    useCreateExpenseMutation,
    useDeleteExpenseMutation,
    useUpdateExpenseMutation,
    useFetchExpensesQuery
} = expenseApi;
export {expenseApi};